
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iFaMg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $l998X = parcelRequire("l998X");










/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");


var $6fnsQ = parcelRequire("6fnsQ");

function $ad7aee5d47af256f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ad7aee5d47af256f$var$baseShadow = '0 0 0 3px';
const $ad7aee5d47af256f$var$basePulseColor = `var(--ds-border-accent-purple, ${(0, $6fnsQ).P75})`;
const $ad7aee5d47af256f$var$basePulseShadowColor = "var(--ds-border-accent-purple, rgba(101, 84, 192, 1))";
const $ad7aee5d47af256f$var$easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const $ad7aee5d47af256f$var$pulseAnimation = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '@keyframes pulseKeyframes': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '0%': {
            opacity: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '50%': {
            opacity: 1
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '100%': {
            opacity: 0
        }
    },
    animationName: 'pulseKeyframes',
    animationDuration: '3000ms',
    animationTimingFunction: $ad7aee5d47af256f$var$easing,
    animationIterationCount: 'infinite'
});
const $ad7aee5d47af256f$var$pseudoStyle = {
    name: "24nntw",
    styles: "content:'';position:absolute;top:0;left:0;width:100%;height:100%"
};
const $ad7aee5d47af256f$export$814d9bf8c56ac913 = ({ hasPulse: hasPulse, pulseBorderRadius: pulseBorderRadius, pulseColor: pulseColor, pulseShadowColor: pulseShadowColor })=>/*#__PURE__*/ (0, $9K4OG.css)({
        display: 'block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> *': {
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '&::before': [
                $ad7aee5d47af256f$var$pseudoStyle,
                {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    borderRadius: `${pulseBorderRadius}px`,
                    boxShadow: `${$ad7aee5d47af256f$var$baseShadow} ${pulseColor}`,
                    opacity: hasPulse ? 1 : 0,
                    transition: 'opacity 0.1s ease-in-out',
                    pointerEvents: 'none'
                }
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '&::after': [
                $ad7aee5d47af256f$var$pseudoStyle,
                {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    borderRadius: `${pulseBorderRadius}px`,
                    boxShadow: `${$ad7aee5d47af256f$var$baseShadow} ${pulseColor}, 0 0 11px ${pulseShadowColor}`,
                    opacity: 0,
                    pointerEvents: 'none'
                },
                hasPulse && $ad7aee5d47af256f$var$pulseAnimation
            ]
        }
    });
const $ad7aee5d47af256f$export$2d11151259bb3b10 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ hasPulse: hasPulse, pulseBorderRadius: pulseBorderRadius = 3, pulseColor: pulseColor = $ad7aee5d47af256f$var$basePulseColor, pulseShadowColor: pulseShadowColor = $ad7aee5d47af256f$var$basePulseShadowColor, tag: TargetContainer = 'span', ...rest }, ref)=>{
    // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    return /*#__PURE__*/ (0, $9K4OG.jsx)(CastTargetContainer, {
        css: [
            $ad7aee5d47af256f$export$814d9bf8c56ac913({
                hasPulse: hasPulse,
                pulseBorderRadius: pulseBorderRadius,
                pulseColor: pulseColor,
                pulseShadowColor: pulseShadowColor
            }),
            $ad7aee5d47af256f$var$inHeritWidthStyles
        ],
        ref: ref,
        ...rest
    });
});
const $ad7aee5d47af256f$var$inHeritWidthStyles = {
    name: "6n1ert",
    styles: "width:inherit"
};


const $29992d3b9988a368$export$b7d614104f4a4a7c = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, nudgeTestId: nudgeTestId, ...rest }, ref)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $ad7aee5d47af256f$export$2d11151259bb3b10), {
        ...rest,
        ref: ref,
        "data-testid": nudgeTestId,
        children: children
    }));



var $caX7N = parcelRequire("caX7N");


var $lqsSp = parcelRequire("lqsSp");


var $fFa3V = parcelRequire("fFa3V");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 








function $a7e0fadb3f4108bd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a7e0fadb3f4108bd$var$borderRadius = 3;
const $a7e0fadb3f4108bd$var$containerStyles = {
    color: `var(--ds-text-inverse, ${(0, $6fnsQ.N0)})`,
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $6fnsQ.N50A)}, 0 0 1px ${(0, $6fnsQ.N60A)}`})`,
    backgroundColor: `var(--ds-background-discovery-bold, ${(0, $6fnsQ.P300)})`,
    borderRadius: `${$a7e0fadb3f4108bd$var$borderRadius}px`,
    overflow: 'auto'
};
const $a7e0fadb3f4108bd$var$bodyStyles = {
    display: 'flex',
    flexDirection: 'column',
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-250, 20px)"}`
};
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
const $a7e0fadb3f4108bd$var$headingStyles = {
    name: "1m05p0r",
    styles: "font-size:1.42857em;font-style:inherit;line-height:1.2;font-weight:var(--ds-font-weight-medium, 500);margin-top:28px;color:inherit;&:first-child{margin-top:0;}"
};
const $a7e0fadb3f4108bd$var$headerStyles = {
    display: 'flex',
    paddingBottom: "var(--ds-space-100, 8px)",
    alignItems: `baseline`,
    justifyContent: `space-between`
};
const $a7e0fadb3f4108bd$var$footerStyles = {
    display: 'flex',
    paddingTop: "var(--ds-space-100, 8px)",
    alignItems: 'center',
    justifyContent: 'space-between'
};
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
const $a7e0fadb3f4108bd$var$actionItemStyles = (index)=>/*#__PURE__*/ (0, $9K4OG.css)({
        margin: `0 ${"var(--ds-space-050, 4px)"}`,
        cursor: 'pointer',
        alignItems: 'baseline',
        borderWidth: '0px',
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
        borderRadius: "var(--ds-radius-small, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography -- TODO: https://product-fabric.atlassian.net/browse/PYX-881
        fontSize: 'inherit',
        fontStyle: 'normal',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        maxWidth: '100%',
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out 0s, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        background: index ? `var(--ds-background-discovery-bold, ${0, $6fnsQ.P300})` : `var(--ds-background-inverse-subtle, ${0, $6fnsQ.P400})`,
        height: '2.28571em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '2.28571em',
        padding: '0px 10px',
        verticalAlign: 'middle',
        width: 'auto',
        justifyContent: 'center',
        color: `var(--ds-text-inverse, ${(0, $6fnsQ.N0)})`,
        '&:hover': {
            backgroundColor: `var(--ds-interaction-hovered, ${(0, $6fnsQ.P200)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-interaction-pressed, ${(0, $6fnsQ.P200)})`
        }
    });
const $a7e0fadb3f4108bd$var$ActionItem = ({ index: index, ...rest })=>/*#__PURE__*/ (0, $9K4OG.jsx)("button", {
        css: $a7e0fadb3f4108bd$var$actionItemStyles(index),
        ...rest
    });
const $a7e0fadb3f4108bd$var$actionItemContainerStyles = {
    display: 'flex',
    margin: `${"var(--ds-space-negative-050, -4px)"}`,
    flexDirection: 'row-reverse'
};
const $a7e0fadb3f4108bd$export$b3ae98194e057550 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ image: image, heading: heading, actions: actions, actionsBeforeElement: actionsBeforeElement, width: width = 300, cardTestId: cardTestId, content: content, id: id }, ref)=>{
    const renderedActions = (0, $42omo.useMemo)(()=>actions?.map(({ text: text, onClick: onClick }, index)=>/*#__PURE__*/ (0, $9K4OG.jsx)($a7e0fadb3f4108bd$var$ActionItem, {
                index: index,
                onClick: onClick,
                key: `${text}-${index}`
            }, text)), [
        actions
    ]);
    const renderHeader = !!heading;
    const renderFooter = !!actionsBeforeElement || !!actions;
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            ...$a7e0fadb3f4108bd$var$containerStyles,
            width: `${width}px`
        },
        "data-testid": cardTestId
    }, typeof image === 'string' ? /*#__PURE__*/ (0, $9K4OG.jsx)("img", {
        src: image,
        alt: ""
    }) : image, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        style: $a7e0fadb3f4108bd$var$bodyStyles,
        id: id
    }, renderHeader && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        style: $a7e0fadb3f4108bd$var$headerStyles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        id: "nudge-spot-light-card-heading",
        css: $a7e0fadb3f4108bd$var$headingStyles
    }, heading)), content, renderFooter && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        style: $a7e0fadb3f4108bd$var$footerStyles
    }, actionsBeforeElement || /*#__PURE__*/ (0, $9K4OG.jsx)("span", null), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        style: $a7e0fadb3f4108bd$var$actionItemContainerStyles
    }, renderedActions))));
});
var $a7e0fadb3f4108bd$export$2e2bcd8739ae039 = $a7e0fadb3f4108bd$export$b3ae98194e057550;












var $7uLCZ = parcelRequire("7uLCZ");

/* Transition.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");







const $4b7877c483e6597b$var$styles = {
    root: "_k8m0brmi _6fl41ytf _1oecfnf5",
    hidden: "_tzy4idpf",
    visible: "_tzy4kb7n"
};
const $4b7877c483e6597b$export$19ffa8f511f7bc2e = /*#__PURE__*/ (0, $42omo.forwardRef)(({ containerStyles: containerStyles, zIndex: zIndex, ariaLabelledBy: ariaLabelledBy, shouldBlink: shouldBlink, stopBlink: stopBlink, ...rest }, ref)=>{
    const [opacityStyle, setOpacityStyle] = (0, $42omo.useState)('hidden');
    (0, $42omo.useEffect)(()=>{
        setTimeout(()=>{
            // to get transition to work properly
            setOpacityStyle(!shouldBlink ? 'visible' : 'hidden');
        }, 0);
        if (shouldBlink) setTimeout(()=>{
            stopBlink();
        }, 200);
    }, [
        shouldBlink,
        stopBlink
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $caX7N.default), {
        zIndex: zIndex,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            ref: ref,
            style: containerStyles,
            "aria-labelledby": ariaLabelledBy,
            ...rest,
            className: (0, $gMc0m.default)([
                $4b7877c483e6597b$var$styles.root,
                $4b7877c483e6597b$var$styles[opacityStyle]
            ])
        })
    });
});
const $4b7877c483e6597b$export$be58926105124dd4 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ containerStyles: containerStyles, zIndex: zIndex, ariaLabelledBy: ariaLabelledBy, shouldBlink: shouldBlink, showSpotlight: showSpotlight, stopBlink: stopBlink, ...rest }, ref)=>{
    return showSpotlight && /*#__PURE__*/ (0, $l998X.jsx)($4b7877c483e6597b$export$19ffa8f511f7bc2e, {
        containerStyles: containerStyles,
        ref: ref,
        ariaLabelledBy: ariaLabelledBy,
        stopBlink: stopBlink,
        shouldBlink: shouldBlink,
        zIndex: zIndex,
        ...rest
    });
});


const $32f6e4307bc25262$export$474e8ee88cc7cd8f = 200;
const $32f6e4307bc25262$export$3d6f334bf7dc4597 = 120;
const $32f6e4307bc25262$var$defaultTransitionStyles = {
    opacity: 0,
    transitionProperty: 'opacity',
    transitionTimingFunction: 'ease-in-out',
    transitionDuration: `${$32f6e4307bc25262$export$474e8ee88cc7cd8f}ms`
};
const $32f6e4307bc25262$var$statefulTransitionStyles = {
    entering: {},
    entered: {
        opacity: 1
    },
    exiting: {
        transitionDuration: `${$32f6e4307bc25262$export$3d6f334bf7dc4597}ms`,
        opacity: 0
    },
    exited: {},
    unmounted: {}
};
const $32f6e4307bc25262$var$timeoutDurations = {
    enter: 0,
    exit: $32f6e4307bc25262$export$3d6f334bf7dc4597
};
const $32f6e4307bc25262$export$d0f55839b708c0a0 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ containerStyles: containerStyles, showSpotlight: showSpotlight, shouldBlink: shouldBlink, zIndex: zIndex, stopBlink: stopBlink, ariaLabelledBy: ariaLabelledBy, shouldUseReactTransitionGroup: shouldUseReactTransitionGroup = true, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: shouldUseReactTransitionGroup ? /*#__PURE__*/ (0, $l998X.jsx)((0, $7uLCZ.default), {
            appear: true,
            in: showSpotlight && !shouldBlink,
            timeout: $32f6e4307bc25262$var$timeoutDurations,
            onExited: stopBlink,
            unmountOnExit: !shouldBlink,
            children: (state)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $caX7N.default), {
                    zIndex: zIndex,
                    children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        style: {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            ...containerStyles,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            ...$32f6e4307bc25262$var$defaultTransitionStyles,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            ...$32f6e4307bc25262$var$statefulTransitionStyles[state]
                        },
                        ref: ref,
                        "aria-labelledby": ariaLabelledBy,
                        ...rest
                    })
                })
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $4b7877c483e6597b$export$be58926105124dd4), {
            containerStyles: containerStyles,
            ref: ref,
            ariaLabelledBy: ariaLabelledBy,
            stopBlink: stopBlink,
            shouldBlink: shouldBlink,
            showSpotlight: showSpotlight,
            zIndex: zIndex,
            ...rest
        })
    });
});



var $5zdke = parcelRequire("5zdke");

const $2da3d51e2f5cb9f8$var$blinkNudge = (nudgeBlinkId, eventTarget, setAnimateIn)=>{
    const nudgeBlinkTriggers = Array.from(document.querySelectorAll(`[data-nudge-blink='${nudgeBlinkId}']`));
    const clickIsInsideTrigger = nudgeBlinkTriggers?.some((triggerElement)=>{
        return triggerElement && triggerElement.contains(eventTarget);
    });
    if (clickIsInsideTrigger) {
        // Blink the nudge
        setAnimateIn(true);
        return true;
    }
    return false;
};
const $2da3d51e2f5cb9f8$export$eebbda33f5d4d735 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ hidden: externalHidden, setHidden: setHidden, hideNudgeOnClick: hideNudgeOnClick = true, hideSpotlightCardOnOutsideClick: hideSpotlightCardOnOutsideClick = true, concealSpotlightOnReferenceHidden: concealSpotlightOnReferenceHidden = false, showSpotlightCardOnFirstRender: showSpotlightCardOnFirstRender = true, children: children, spotlightCard: Spotlight = (0, $a7e0fadb3f4108bd$export$2e2bcd8739ae039), nudge: Nudge = (0, $29992d3b9988a368$export$b7d614104f4a4a7c), position: position = 'bottom', offset: offset, zIndex: zIndex = 800, onRender: onRender, onShow: onShow, onHide: onHide, onClick: onClick, onOutsideClick: onOutsideClick, pulseColor: pulseColor, pulseShadowColor: pulseShadowColor, pulseBorderRadius: pulseBorderRadius, nudgeBlinkId: nudgeBlinkId, nudgeTestId: nudgeTestId, nudgeTag: nudgeTag, headingId: headingId, shouldUseReactTransitionGroup: shouldUseReactTransitionGroup = true, ...spotlightCardProps }, nudgeSpotlightRef)=>{
    // Put all listeners inside a ref to avoid misfiring events
    // When the listener functions themselves change.
    const handlers = (0, $42omo.useRef)();
    handlers.current = {
        onRender: onRender,
        onHide: onHide,
        onShow: onShow,
        onClick: onClick,
        onOutsideClick: onOutsideClick
    };
    const nudgeRef = (0, $42omo.useRef)(null);
    const spotlightCardRef = (0, $42omo.useRef)(null);
    const showNudge = !externalHidden;
    const [canShowSpotlight, setCanShowSpotlight] = (0, $42omo.useState)(showSpotlightCardOnFirstRender);
    const [showSpotlight, setShowSpotlight] = (0, $42omo.useState)(false);
    const [shouldBlink, setShouldBlink] = (0, $42omo.useState)(false);
    const stopBlink = (0, $42omo.useCallback)(()=>setShouldBlink(false), []);
    const forceUpdateFnRef = (0, $42omo.useRef)({
        fn: ()=>{}
    });
    (0, $42omo.useImperativeHandle)(nudgeSpotlightRef, ()=>({
            toggleCardVisibility: setCanShowSpotlight,
            forceUpdateCardPosition: ()=>forceUpdateFnRef.current.fn()
        }), [
        setCanShowSpotlight
    ]);
    const markReadyToShow = (0, $42omo.useCallback)(()=>showNudge && setCanShowSpotlight(true), [
        showNudge
    ]);
    const onTargetClick = (0, $42omo.useCallback)((event)=>{
        if (!externalHidden) {
            if (hideNudgeOnClick) setHidden(event);
            handlers.current?.onClick?.();
        }
    }, [
        externalHidden,
        hideNudgeOnClick,
        setHidden,
        handlers
    ]);
    // Effect for show/hide the spotlight
    (0, $42omo.useEffect)(()=>{
        setShowSpotlight(showNudge && canShowSpotlight);
    }, [
        showNudge,
        canShowSpotlight
    ]);
    // Effect for onRender and onHide
    (0, $42omo.useEffect)(()=>{
        if (!externalHidden) {
            handlers.current?.onRender?.();
            return ()=>handlers.current?.onHide?.();
        }
    }, [
        externalHidden,
        handlers
    ]);
    // Effect for onShow
    (0, $42omo.useEffect)(()=>{
        if (showSpotlight) handlers.current?.onShow?.();
    }, [
        showSpotlight,
        handlers
    ]);
    // Effect to reset showSpotlightCardOnFirstRender when hidden
    (0, $42omo.useEffect)(()=>{
        if (externalHidden) setCanShowSpotlight(showSpotlightCardOnFirstRender);
    }, [
        externalHidden,
        showSpotlightCardOnFirstRender
    ]);
    // Effect to hide spotlight on outside click
    (0, $42omo.useEffect)(()=>{
        let unbind;
        let timeout;
        if (showSpotlight && hideSpotlightCardOnOutsideClick) timeout = window.setTimeout(()=>{
            unbind = (0, $fFa3V.bind)(window, {
                type: 'click',
                listener: (event)=>{
                    const eventTarget = event.target;
                    if (nudgeRef.current && spotlightCardRef.current && eventTarget instanceof Node && !nudgeRef.current.contains(eventTarget) && !spotlightCardRef.current.contains(eventTarget)) {
                        if (nudgeBlinkId) {
                            const didBlink = $2da3d51e2f5cb9f8$var$blinkNudge(nudgeBlinkId, eventTarget, setShouldBlink);
                            if (didBlink) return;
                        }
                        setCanShowSpotlight(false);
                        handlers.current?.onOutsideClick?.(event);
                        unbind?.();
                    }
                },
                options: {
                    capture: true,
                    passive: true
                }
            });
        });
        return ()=>{
            unbind?.();
            window.clearTimeout(timeout);
        };
    }, [
        showSpotlight,
        hideSpotlightCardOnOutsideClick,
        setHidden,
        handlers,
        nudgeBlinkId
    ]);
    const concealSpotlightOnScrollStyles = (isReferenceHidden)=>concealSpotlightOnReferenceHidden && isReferenceHidden ? {
            display: 'none'
        } : {};
    const cardConfig = (0, $42omo.useMemo)(()=>Spotlight === (0, $a7e0fadb3f4108bd$export$2e2bcd8739ae039) ? {
            ...spotlightCardProps,
            id: nudgeBlinkId
        } : {
            cardTestId: spotlightCardProps.cardTestId
        }, [
        Spotlight,
        spotlightCardProps,
        nudgeBlinkId
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)(Nudge, {
                ref: nudgeRef,
                hasPulse: showNudge,
                onClickCapture: onTargetClick,
                onMouseEnter: markReadyToShow,
                pulseColor: pulseColor,
                pulseShadowColor: pulseShadowColor,
                pulseBorderRadius: pulseBorderRadius,
                nudgeTestId: nudgeTestId,
                tag: nudgeTag,
                children: children
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $caX7N.default), {
                zIndex: zIndex,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lqsSp.Popper), {
                    placement: position,
                    referenceElement: nudgeRef.current || undefined,
                    offset: offset,
                    children: ({ ref: ref, style: popperStyles, forceUpdate: forceUpdate, isReferenceHidden: isReferenceHidden })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $32f6e4307bc25262$export$d0f55839b708c0a0), {
                            showSpotlight: showSpotlight,
                            shouldBlink: shouldBlink,
                            stopBlink: stopBlink,
                            zIndex: zIndex,
                            ref: ref,
                            containerStyles: {
                                ...popperStyles,
                                ...concealSpotlightOnScrollStyles(isReferenceHidden)
                            },
                            role: "dialog",
                            ariaLabelledBy: headingId || 'nudge-spot-light-card-heading',
                            shouldUseReactTransitionGroup: shouldUseReactTransitionGroup,
                            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $5zdke.default), {
                                children: [
                                    (forceUpdateFnRef.current.fn = forceUpdate) && null,
                                    /*#__PURE__*/ (0, $l998X.jsx)(Spotlight, {
                                        ...cardConfig,
                                        ref: spotlightCardRef
                                    })
                                ]
                            })
                        })
                })
            })
        ]
    });
});
var $2da3d51e2f5cb9f8$export$2e2bcd8739ae039 = $2da3d51e2f5cb9f8$export$eebbda33f5d4d735;



var $dTk3A = parcelRequire("dTk3A");


var $inPa6 = parcelRequire("inPa6");


var $7Sm4c = parcelRequire("7Sm4c");


var $irVI7 = parcelRequire("irVI7");


var $gfIPU = parcelRequire("gfIPU");

var $1kHsc = parcelRequire("1kHsc");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");


var $1uFM6 = parcelRequire("1uFM6");


var $id4ij = parcelRequire("id4ij");

const $a1b66a9372b16102$var$COMPONENT_NAME = 'nudgeTooltip';
const $a1b66a9372b16102$export$43835e9acf248a15 = (createAnalyticsEvent, { contentId: contentId, actionSubjectId: actionSubjectId, actionSubject: actionSubject, source: source, action: action, type: type, attributes: attributes })=>{
    createAnalyticsEvent({
        type: type,
        data: {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            source: source,
            attributes: {
                ...contentId ? {
                    contentId: contentId
                } : {},
                nudgeTarget: actionSubjectId,
                componentName: $a1b66a9372b16102$var$COMPONENT_NAME,
                ...attributes
            }
        }
    }).fire();
};


const $2834702a20a1816a$export$d34bba8c7068f876 = {};
const $2834702a20a1816a$export$8005c110df91a313 = (fn, { interval: interval = 500, cycles: cycles = 10 })=>{
    let i = 0;
    const timer = setInterval(()=>{
        fn?.();
        i++;
        if (i === cycles) clearInterval(timer);
    }, interval);
    return timer;
};
function $2834702a20a1816a$var$isErrorHandled(error) {
    // Mark unauthorized error as handled and not report to monitoring client
    if ((0, $1uFM6.isUnauthorizedError)(error) || error?.graphQLErrors?.[0]?.message === 'unauthorized') {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    return false;
}
const $2834702a20a1816a$export$96dfbdc3eda1cd3a = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { hidden: hidden, children: children, source: source, actionSubjectId: actionSubjectId, heading: heading, content: content, width: width = 320, wrapper: wrapper, zIndex: zIndex = (0, $dTk3A.layers).blanket(), position: position, offset: offset, onShow: onShow, onHide: onHide, onClick: onClick, onOutsideClick: onOutsideClick, onboardingErrors: onboardingErrors } = props;
    const Wrapper = wrapper || (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment;
    const target = `onboarding-nudge-${actionSubjectId}`;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const nudgeSpotlightRef = (0, $42omo.useRef)(null);
    // used to turn off effects for outsideClick
    const [outsideClicked, setOutsideClicked] = (0, $42omo.useState)(false);
    /**
	 * The point of this local hidden is to hide the nudge when the element is no longer in view
	 * This local hidden value is then changed when the element is back in view.
	 */ const [isLocalHidden, setIsLocalHidden] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (!hidden) experienceTracker.start({
            name: (0, $irVI7.ONBOARDING_NUDGE_EXPERIENCE)
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hidden,
        experienceTracker
    ]);
    // Scroll fix for nudges that will be covered by global nav
    (0, $42omo.useEffect)(()=>{
        let isScrolling;
        const handleMouse = ()=>{
            isScrolling && window.clearTimeout(isScrolling);
            isScrolling = setTimeout(()=>{
                const element = document.getElementById(target);
                if (!element) return;
                let elementInViewport = (0, $id4ij.isElementInViewport)(element);
                // Elements not in the nav bar sometimes get hidden by the nav bar
                elementInViewport = element.getBoundingClientRect().top > 40;
                setIsLocalHidden(!elementInViewport);
            }, 250);
        };
        if (!hidden) window.addEventListener('scroll', handleMouse, true);
        return ()=>{
            window.removeEventListener('scroll', handleMouse, true);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hidden,
        outsideClicked
    ]);
    // Timer to account for lazily loaded components and to update tooltip position with a force rerender
    (0, $42omo.useEffect)(()=>{
        let timer;
        if (!hidden && nudgeSpotlightRef && nudgeSpotlightRef.current) timer = $2834702a20a1816a$export$8005c110df91a313(nudgeSpotlightRef?.current?.forceUpdateCardPosition, {
            interval: 500,
            cycles: 10
        });
        return ()=>{
            clearInterval(timer);
        };
    }, [
        nudgeSpotlightRef,
        hidden
    ]);
    // ------ Behavioral Callbacks ------
    const handleOnHide = ()=>{
        (0, $a1b66a9372b16102$export$43835e9acf248a15)(createAnalyticsEvent, {
            type: 'sendTrackEvent',
            source: source,
            actionSubjectId: actionSubjectId,
            actionSubject: 'nudgeTooltip',
            action: 'hidden'
        });
        onHide?.();
    };
    const handleOnClick = ()=>{
        (0, $a1b66a9372b16102$export$43835e9acf248a15)(createAnalyticsEvent, {
            type: 'sendTrackEvent',
            source: source,
            actionSubjectId: actionSubjectId,
            actionSubject: 'nudgeTooltip',
            action: 'clicked'
        });
        onClick?.();
        experienceTracker.succeed({
            name: (0, $irVI7.ONBOARDING_NUDGE_EXPERIENCE)
        });
    };
    const handleOnShow = ()=>{
        (0, $a1b66a9372b16102$export$43835e9acf248a15)(createAnalyticsEvent, {
            type: 'sendTrackEvent',
            source: source,
            actionSubjectId: actionSubjectId,
            actionSubject: 'nudgeTooltip',
            action: 'shown'
        });
        onShow?.();
    };
    const handleOnOutsideClick = ()=>{
        onOutsideClick?.();
        setOutsideClicked(true);
    };
    // If there is a known error it should not display the nudge the priority of error is higher than hidden
    if (onboardingErrors && onboardingErrors.length) {
        const ErrorDisplays = onboardingErrors.filter((error)=>{
            return !$2834702a20a1816a$var$isErrorHandled(error);
        }).map((error)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error,
                key: error.message
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfIPU.ExperienceFailure), {
                name: (0, $irVI7.ONBOARDING_NUDGE_EXPERIENCE),
                error: error,
                key: error.message,
                attributes: {
                    source: source,
                    actionSubjectId: actionSubjectId
                }
            }));
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children, ErrorDisplays);
    }
    return hidden || isLocalHidden ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2da3d51e2f5cb9f8$export$eebbda33f5d4d735), {
        ...props,
        ref: nudgeSpotlightRef,
        heading: heading,
        content: content,
        width: width,
        hidden: hidden || isLocalHidden,
        hideNudgeOnClick: true,
        hideSpotlightCardOnOutsideClick: true,
        onHide: handleOnHide,
        onShow: handleOnShow,
        onClick: handleOnClick,
        onOutsideClick: handleOnOutsideClick,
        zIndex: zIndex,
        position: position,
        offset: offset
    }, children));
};
const $2834702a20a1816a$export$c09847f3a2ea8c56 = (props)=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const failedOnboardingNudge = (0, $42omo.useCallback)((error)=>{
        experienceTracker.fail({
            name: (0, $irVI7.ONBOARDING_NUDGE_EXPERIENCE),
            error: error
        });
    }, [
        experienceTracker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eCryJ.GenericErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).FLYWHEEL_ACTIVATION,
        onError: failedOnboardingNudge,
        renderOnError: ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.children);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2834702a20a1816a$export$96dfbdc3eda1cd3a, props));
};
module.exports["ELEMENTS_NOT_IN_NAV"] = $2834702a20a1816a$export$d34bba8c7068f876;
module.exports["autoAdjustPosition"] = $2834702a20a1816a$export$8005c110df91a313;
module.exports["OnboardingNudgeComponent"] = $2834702a20a1816a$export$96dfbdc3eda1cd3a;
module.exports["OnboardingNudge"] = $2834702a20a1816a$export$c09847f3a2ea8c56;

});

parcelRegister("gfIPU", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $5675860ef242c9e4$export$eed1d73ebdd8c7ab(t0) {
    const $ = (0, $frIzR.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>experienceTracker.fail({
                name: name,
                error: error,
                attributes: attributes
            });
        t2 = [
            experienceTracker,
            name,
            error,
            attributes
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceFailure"] = $5675860ef242c9e4$export$eed1d73ebdd8c7ab;

});

parcelRegister("id4ij", function(module, exports) {
function $21c1903a8ac50cbe$export$f25538161b7e9c17(element) {
    let top = element.offsetTop;
    while(element.offsetParent){
        element = element.offsetParent;
        top += element.offsetTop;
    }
    return top;
}
function $21c1903a8ac50cbe$export$7cc0e9dd2435cb30(element, container) {
    if (!element) return false;
    container = container || document.scrollingElement || document.body.parentNode;
    if (!container) return false;
    const height = element.offsetHeight;
    const top = $21c1903a8ac50cbe$export$f25538161b7e9c17(element);
    const containerTop = $21c1903a8ac50cbe$export$f25538161b7e9c17(container) + container.scrollTop;
    const containerHeight = container.offsetHeight;
    return top >= containerTop && top + height <= containerTop + containerHeight;
}
function $21c1903a8ac50cbe$export$e41e80160bed5714(node) {
    // @ts-ignore
    if (!node || node === document) return null;
    const nodeStyle = window.getComputedStyle(node);
    if (node.scrollHeight > node.clientHeight && node.style.overflow !== 'hidden' && nodeStyle.overflow !== 'visible') return node;
    else return $21c1903a8ac50cbe$export$e41e80160bed5714(node.parentNode);
}
function $21c1903a8ac50cbe$export$c3e8c6d4b3b72bf2(element, container) {
    container = container || $21c1903a8ac50cbe$export$e41e80160bed5714(element);
    if (!element || !container || $21c1903a8ac50cbe$export$7cc0e9dd2435cb30(element, container)) return;
    container.scrollTop = $21c1903a8ac50cbe$export$f25538161b7e9c17(element) - $21c1903a8ac50cbe$export$f25538161b7e9c17(container) - container.clientHeight / 2;
}
function $21c1903a8ac50cbe$export$abe5643cba19555f(element) {
    return element.getBoundingClientRect();
}
function $21c1903a8ac50cbe$export$4c0864c7defafad3(element, documentObject) {
    const docEl = documentObject ? documentObject.documentElement : window.document.documentElement;
    if (!element || !docEl) return;
    const boundaries = element.getBoundingClientRect();
    const { top: top, bottom: bottom } = boundaries;
    const viewportHeight = docEl.offsetHeight;
    const topIsVisible = 0 <= top && top < viewportHeight;
    const bottomIsVisible = 0 <= bottom && bottom <= viewportHeight;
    const isBiggerThanViewPort = top <= 0 && 0 <= bottom && bottom >= viewportHeight;
    return topIsVisible || bottomIsVisible || isBiggerThanViewPort;
}
function $21c1903a8ac50cbe$export$4acade851e875ad4(element, documentObject) {
    const docEl = documentObject ? documentObject.documentElement : window.document.documentElement;
    if (!element || !docEl) return;
    const boundaries = element.getBoundingClientRect();
    const { top: top } = boundaries;
    const viewportHeight = docEl.offsetHeight;
    const topIsVisible = 0 <= top && top < viewportHeight;
    return topIsVisible;
}
function $21c1903a8ac50cbe$export$5513bf0589d602a4(targetDomElementId, htmlMarkup) {
    let el = document.getElementById(targetDomElementId);
    if (!el) {
        el = document.createElement('div');
        el.setAttribute('id', targetDomElementId);
        el.setAttribute('style', 'display: none');
        document.body.appendChild(el);
        el = document.getElementById(targetDomElementId);
    }
    if (!el) return;
    el.innerHTML = '';
    if (htmlMarkup) {
        const range = document.createRange();
        const fragment = range.createContextualFragment(htmlMarkup);
        el.appendChild(fragment);
    }
}
module.exports["getElementTop"] = $21c1903a8ac50cbe$export$f25538161b7e9c17;
module.exports["isElementInViewport"] = $21c1903a8ac50cbe$export$7cc0e9dd2435cb30;
module.exports["scrollElementToViewCenter"] = $21c1903a8ac50cbe$export$c3e8c6d4b3b72bf2;
module.exports["getElementBounds"] = $21c1903a8ac50cbe$export$abe5643cba19555f;
module.exports["isPartOfElementStillInViewPort"] = $21c1903a8ac50cbe$export$4c0864c7defafad3;
module.exports["isTopOfElementStillInViewPort"] = $21c1903a8ac50cbe$export$4acade851e875ad4;
module.exports["replaceDomElementContent"] = $21c1903a8ac50cbe$export$5513bf0589d602a4;

});


//# sourceMappingURL=OnboardingNudgeTooltip.a11a708f.js.map
